import { useCallback, useContext, useEffect, useState } from "react";
import {
  filterCompletedJobStatuses,
  publishCompletedPromotionCompilationJobStatuses,
  publishExpiredPromotionCompilationJobStatuses,
  removeCompletedAndExpiredPromotionCompilationJobs,
} from "./usePromotionDownloadNotifierHelpers";
import { ConfigContext } from "../../context/ConfigContext";
import { DOWNLOAD_JOB_ADDED } from "../../utils/eventConstants";
import {
  getPendingDownloadJobs,
  PendingPromotionCompilationJob,
} from "../../utils/promotions/promotionUtils";
import usePromotionDownloadStatus from "../usePromotionDownloadStatus/usePromotionDownloadStatus";

const usePromotionDownloadNotifier = (accountId: string) => {
  const [pendingJobs, setPendingJobs] = useState<
    PendingPromotionCompilationJob[]
  >([]);
  const { downloadStatuses } = usePromotionDownloadStatus(
    accountId,
    pendingJobs.map((job) => job.jobId)
  );
  const { PROMOTION_DOWNLOAD_JOB_TIMEOUT = 15000 } = useContext(ConfigContext);

  const handler = useCallback(() => {
    const pendingPromotionDownloadJobs = getPendingDownloadJobs(accountId);
    setPendingJobs(pendingPromotionDownloadJobs);
  }, [accountId]);

  useEffect(() => {
    window.addEventListener(DOWNLOAD_JOB_ADDED, handler);
    return () => window.removeEventListener(DOWNLOAD_JOB_ADDED, handler);
  }, [accountId]);

  useEffect(() => {
    const completedJobStatuses = filterCompletedJobStatuses(downloadStatuses);
    const { remainingJobs, expiredJobs } =
      removeCompletedAndExpiredPromotionCompilationJobs(
        accountId,
        completedJobStatuses,
        PROMOTION_DOWNLOAD_JOB_TIMEOUT
      );
    publishCompletedPromotionCompilationJobStatuses(completedJobStatuses);
    publishExpiredPromotionCompilationJobStatuses(expiredJobs);
    setPendingJobs([...remainingJobs]);
  }, [downloadStatuses, accountId]);
};

export default usePromotionDownloadNotifier;
